/* eslint-disable */
import Csv from '!!raw-loader!../data/towary.csv';

const Papa = require('papaparse');

class SearchProductData {
    constructor() {
        this.records = [];
    }

    async loadCSV() {
        // const fileContent = ;
        const result = Papa.parse(Csv, {
            header: true,
            skipEmptyLines: true,
        });
        this.records = result.data;
    }

    findByFields({
                     AlfabetZnak,
                     CzcionkaId,
                     MocowanieId,
                     RozmiarId,
                     MaterialId,
                     WykonczenieId,
                     KolorId
                 }) {
        const result = this.records.find(record =>
            record.AlfabetZnak === AlfabetZnak &&
            record.CzcionkaId === String(CzcionkaId) &&
            //record.MocowanieId === String(MocowanieId) &&
            record.RozmiarId === String(RozmiarId)
            //record.MaterialId === String(MaterialId) &&
            //record.WykonczenieId === String(WykonczenieId) &&
            //(record.KolorId === "" + KolorId || (!record.KolorId && (KolorId === null || KolorId === undefined)))
        );
        //from result filter
        return result;
    }
}

const search = new SearchProductData();
search.loadCSV();

function searchByField({
                           AlfabetZnak,
                           CzcionkaId,
                           MocowanieId,
                           RozmiarId,
                           MaterialId,
                           WykonczenieId,
                           KolorId
                       }) {
    return search.findByFields({
        AlfabetZnak,
        CzcionkaId,
        MocowanieId,
        RozmiarId,
        MaterialId,
        WykonczenieId,
        KolorId
    });
}

export default searchByField;
